module.exports = __webpack_public_path__ + "static/media/Asset 4.eea5a594.svg";